import { css, cx } from 'emotion';
import {
	helvetica,
	label,
	lightGrey,
	textBlock,
	mobileMaxWidthBreakpoint,
	desktopMaxWidthBreakpoint,
} from 'inside-out/global-styles';

export const wrapperStyle = css({
	...helvetica,
	borderTop: `1px solid ${lightGrey}`,
});

export const mobileSocialIconsStyle = css({
	display: 'none',
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		display: 'block',
		marginBottom: '30px',
		padding: '0 30px',
	},
});

export const innerWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	height: '100%',
	margin: '0 auto',
	padding: '60px 20px',
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		padding: '20px 10px',
	},
});

export const innerWrapperStyleHidden = css({
	...innerWrapperStyle,
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		display: 'none',
	},
});

export const innerWrapperStyleShown = innerWrapperStyle;

export const columnsStyle = css({
	display: 'flex',
});

export const logoStyle = css({
	padding: '0 20px 0 0',
	'& > img:first-child': {
		width: '158px',
		height: '54px',
		marginBottom: '30px',
	},
	'& [data-component=SocialIcons]': {
		padding: '0 10px',
	},
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		display: 'none',
	},
});

export const menuIconStyle = css({
	'& img': {
		width: '20px',
		height: '20px',
		float: 'right',
		padding: '10px',
	},
	[`@media (min-width: ${mobileMaxWidthBreakpoint}px)`]: {
		'& img': {
			display: 'none',
		},
	},
});

export const closeIconStyle = css({
	'& img': {
		width: '20px',
		height: '20px',
		float: 'right',
		padding: '10px',
	},
	[`@media (min-width: ${mobileMaxWidthBreakpoint}px)`]: {
		'& img': {
			display: 'none',
		},
	},
});

export const topSectionMobile = css({
	width: '100%',
	maxWidth: desktopMaxWidthBreakpoint,
});

export const sectionsStyle = css({
	display: 'flex',
	flexWrap: 'wrap',
	flexDirection: 'row',
	justifyContent: 'flex-start',
	alignItems: 'flex-start',
	alignContent: 'flex-start',
	margin: '-10px 0 0 0',
	'& > div': {
		padding: '10px',
		minWidth: '110px',
		'&:last-child': {
			paddingRight: 0,
		},
	},
});

export const sectionTitleStyle = cx(
	label,
	css({
		marginBottom: '17px',
	})
);

export const termsAndCopyrightWrapper = css({
	borderTop: `1px solid ${lightGrey}`,
});

export const termsAndCopyright = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	height: '100%',
	margin: '0 auto',
	display: 'table',
	padding: '15px 20px',
	'& nav': {
		display: 'table-cell',
		a: cx(
			textBlock,
			css({
				textDecoration: 'none',
				fontSize: '14px',
				lineHeight: '22px',
				'&:not(:last-child)': {
					marginRight: '40px',
					position: 'relative',
					'&:after': {
						content: "'•'",
						display: 'block',
						position: 'absolute',
						transform: 'translate(-50%, -50%)',
						left: 'calc(100% + 20px)',
						top: '50%',
					},
				},
			})
		),
	},
	'& p': {
		margin: '0',
		display: 'table-cell',
		textAlign: 'right',
		fontSize: '14px',
		lineHeight: '22px',
		color: '#8A8B8C',
	},
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		display: 'block',
		'& nav, & p': {
			display: 'block',
			textAlign: 'left',
		},
		'& p': {
			marginTop: '15px',
		},
	},
});



// WEBPACK FOOTER //
// ./src/components/shared/footer/styles.js